import { SdkContext, normalizeLocale } from './sdk-official/internal'
import { LogsResource } from './sdk-official/resources/logs'
import { EngagementResource } from './sdk-official/resources/engagement'
import { AnalyticsResource } from './sdk-official/resources/analytics'
import { AuthResource } from './sdk-official/resources/auth'
import { Call4PapersResource } from './sdk-official/resources/call4papers'
import { CertificatesResource } from './sdk-official/resources/certificates'
import { CampaignsResource } from './sdk-official/resources/campaigns'
import { DashboardResource } from './sdk-official/resources/dashboard'
import { ClassifiedsResource } from './sdk-official/resources/classifieds'
import { AttendanceResource } from './sdk-official/resources/attendance'
import { VisitorsResource } from './sdk-official/resources/visitors'
import { BookingsResource } from './sdk-official/resources/bookings'
import { SchedulingResource } from './sdk-official/resources/scheduling'
import { ParcelsResource } from './sdk-official/resources/parcels'
import { VirtualOfficeResource } from './sdk-official/resources/virtualOffice'
import { CompaniesResource } from './sdk-official/resources/companies'
import { SupportResource } from './sdk-official/resources/support'
import { CreditsResource } from './sdk-official/resources/credits'
import { DownloadsResource } from './sdk-official/resources/downloads'
import { AdminMediaResource } from './sdk-official/resources/admin-media'
import { MediaResource } from './sdk-official/resources/media'
import { StorefrontResource } from './sdk-official/resources/storefront'
import { ReferralsResource } from './sdk-official/resources/referrals'
import { PointsResource } from './sdk-official/resources/points'
import { CommunitiesResource } from './sdk-official/resources/communities'
import { ContentResource } from './sdk-official/resources/content'
import { CoursesResource } from './sdk-official/resources/courses'
import { EventsResource } from './sdk-official/resources/events'
import { FeedResource } from './sdk-official/resources/feed'
import { GalleryResource } from './sdk-official/resources/gallery'
import { GamificationResource } from './sdk-official/resources/gamification'
import { BadgesResource } from './sdk-official/resources/badges'
import { SignupRequestsResource } from './sdk-official/resources/signup-requests'
import { MembersResource } from './sdk-official/resources/members'
import { SectionsResource } from './sdk-official/resources/sections'
import { SpacesResource } from './sdk-official/resources/spaces'
import { HierarchyResource, MemberGroupsResource } from './sdk-official/resources/hierarchy'
import { MemberFieldsResource, MemberImportsResource, InviteOptOutResource } from './sdk-official/resources/member-import'
import { ContentImportsResource } from './sdk-official/resources/content-import'
import { StatusResource } from './sdk-official/resources/status'
import { EmbedsResource } from './sdk-official/resources/embeds'
import { AiResource } from './sdk-official/resources/ai'
import { PollsResource } from './sdk-official/resources/polls'
import { SurveysResource } from './sdk-official/resources/surveys'
import { FormsResource } from './sdk-official/resources/forms'
import { ExportsResource } from './sdk-official/resources/exports'
import { PrivacyResource } from './sdk-official/resources/privacy'
import { RecognitionsResource } from './sdk-official/resources/recognitions'
import { DevelopmentPlansResource } from './sdk-official/resources/development-plans'
import { TimeTrackingResource } from './sdk-official/resources/time-tracking'
import { PerformanceReviewsResource } from './sdk-official/resources/performance-reviews'
import { GoalsResource } from './sdk-official/resources/goals'
import { OneOnOnesResource } from './sdk-official/resources/one-on-ones'
import { UpvotesResource } from './sdk-official/resources/upvotes'
import { NetworkingResource } from './sdk-official/resources/networking'
import { MediaShowsResource } from './sdk-official/resources/media-shows'
import { PlayerNotesResource } from './sdk-official/resources/player-notes'
import { TwoFactorResource } from './sdk-official/resources/two-factor'
import { DayPassesResource } from './sdk-official/resources/day-passes'
import { ChannelsResource } from './sdk-official/resources/channels'
import { FeedbacksResource } from './sdk-official/resources/feedbacks'
import { EmailNoticesResource } from './sdk-official/resources/email-notices'
import { PushResource } from './sdk-official/resources/push'
import { SmsResource } from './sdk-official/resources/sms'
import { WhatsappResource } from './sdk-official/resources/whatsapp'
import { EmailsResource } from './sdk-official/resources/emails'
import { VaultResource } from './sdk-official/resources/vault'
import { WelcomeResource } from './sdk-official/resources/welcome'
import { ScheduledPostsResource } from './sdk-official/resources/scheduled-posts'
import { WorkflowsResource } from './sdk-official/resources/workflows'
import { ChatResource } from './sdk-official/resources/chat'
import { RealtimeResource } from './sdk-official/resources/realtime'
import { SubscriptionsResource } from './sdk-official/resources/subscriptions'
import { SubscriptionAdminResource } from './sdk-official/resources/subscription-admin'
import { SalesResource } from './sdk-official/resources/sales'
import { AbandonedCartsResource } from './sdk-official/resources/abandoned-carts'
import { IntegrationsResource } from './sdk-official/resources/integrations'
import { WebhooksResource } from './sdk-official/resources/webhooks'
import { AppsResource } from './sdk-official/resources/apps'
import { UploadResource } from './sdk-official/resources/upload'
import { BusinessInformationResource } from './sdk-official/resources/business-information'
import { PayoutSettingsResource } from './sdk-official/resources/payout-settings'
import { NotificationsResource } from './sdk-official/resources/notifications'
import { SearchResource } from './sdk-official/resources/search'
import { PaymentMethodsResource } from './sdk-official/resources/payment-methods'
import { DownsellResource } from './sdk-official/resources/downsell'
import { AdminFeesResource } from './sdk-official/resources/admin-fees'
import { AdminCommunitiesResource } from './sdk-official/resources/admin-communities'
import { AdminSendingReputationResource } from './sdk-official/resources/admin-sending-reputation'
import { EntitlementsResource } from './sdk-official/resources/entitlements'
import { HubListingResource } from './sdk-official/resources/hub-listing'
import { CommunityThemesResource } from './sdk-official/resources/community-themes'
import { AdminCommunityRequestsResource } from './sdk-official/resources/admin-community-requests'
import { McpOAuthResource } from './sdk-official/resources/mcp-oauth'
import { CustomDomainResource } from './sdk-official/resources/custom-domain'
import { VideoIntegrationsResource } from './sdk-official/resources/video-integrations'
import { EmailProviderResource } from './sdk-official/resources/email-provider'
import { clearBlockDrafts } from './realtime/blockDrafts'
import {
  ProductsResource,
  CouponsResource,
  SubscriptionGroupsResource,
  CheckoutResource,
  LedgerResource,
  PayoutsResource,
  FeesResource,
  ReportsResource
} from './sdk-official/resources/monetization'

export { normalizeLocale }

const LOCALE_STORAGE_KEY = 'i18nextLng'
const MEMBER_STORAGE_KEY = 'memberfy_member_id'
/**
 * The community the stored member id was chosen in. `X-MemberId` names a
 * member of one community; carried into another, every write comes back 404.
 */
const MEMBER_COMMUNITY_STORAGE_KEY = 'memberfy_member_community_id'

export class MemberfySDK {
  private ctx: SdkContext
  private currentLocale: string
  private currentCommunityId = ''

  public auth: AuthResource
  public call4papers: Call4PapersResource
  /** F-42: certificate templates, issuance and public verification. */
  public certificates: CertificatesResource
  /** F-73: e-mail campaigns, quota, opt-outs and the member's e-mail preference. */
  public campaigns: CampaignsResource
  /** F-84: the team's Dashboard summary. */
  public dashboard: DashboardResource
  /** F-72: classified ads, images, interests and their moderation. */
  public classifieds: ClassifiedsResource
  public attendance: AttendanceResource
  public visitors: VisitorsResource
  /** F-79: bookable rooms, desks and stations, availability, search and bookings. */
  public bookings: BookingsResource
  /** F-80: Agendamento — offer rules, people search, host page, listing approval. */
  public scheduling: SchedulingResource
  /** F-81: parcels received for residents (Encomendas). */
  public parcels: ParcelsResource
  /** F-245: virtual office (business address, saved addresses, settings). */
  public virtualOffice: VirtualOfficeResource
  /** F-93 1A: companies and their team. */
  public companies: CompaniesResource
  /** F-82: Support tickets between residents and the team. */
  public support: SupportResource
  /** F-79: the member's credits ledger, grants, adjustments and the community's credit rules. */
  public credits: CreditsResource
  /** F-75: downloads — files in a space, free or sold by a download product. */
  public downloads: DownloadsResource
  /** F-76: privately hosted media (upload-url, confirm, signed links). */
  public media: MediaResource
  /** F-76 part 2: SuperAdmin native streaming switch and media cost report. */
  public adminMedia: AdminMediaResource
  public storefront: StorefrontResource
  /** F-159: referral link, settings and report. */
  public referrals: ReferralsResource
  /** F-160: points balance, statement and redeeming. */
  public points: PointsResource
  public communities: CommunitiesResource
  public content: ContentResource
  public courses: CoursesResource
  public events: EventsResource
  public feed: FeedResource
  public gallery: GalleryResource
  public gamification: GamificationResource
  public badges: BadgesResource
  public signupRequests: SignupRequestsResource
  public members: MembersResource
  public sections: SectionsResource
  public spaces: SpacesResource
  public memberGroups: MemberGroupsResource
  /** F-85: custom member fields and their values. */
  public memberFields: MemberFieldsResource
  /** F-85: spreadsheet imports of members. */
  public memberImports: MemberImportsResource
  /** F-91: spreadsheet imports of posts, articles and short posts. */
  public contentImports: ContentImportsResource
  /** F-85: "thanks, but I do not want to join", by e-mail link or from inside. */
  public inviteOptOut: InviteOptOutResource
  public hierarchy: HierarchyResource
  public status: StatusResource
  /** F-92: link embeds for the composer's paste preview. */
  public embeds: EmbedsResource
  /** F-105: "Improve with AI" and the SuperAdmin usage totals. */
  public ai: AiResource
  /** F-41: voting on, editing and closing polls. */
  public polls: PollsResource
  /** F-103: surveys (team, member form, public link). */
  public surveys: SurveysResource
  /** F-109: forms (editor, submissions, member fill, public link). */
  public forms: FormsResource
  /** SEC-216: the download of a big export, from the e-mailed link. */
  public exports: ExportsResource
  /** F-199 and F-200: account erasure and personal data export (the person and the team). */
  public privacy: PrivacyResource
  /** F-53: recognitions, their reactions and comments, company values and the dashboard. */
  public recognitions: RecognitionsResource
  /** F-52: PDI (individual development plans), their actions, the team and the dashboard. */
  public developmentPlans: DevelopmentPlansResource
  /** F-51: time tracking records (establishments, employees, punches, receipts, AFD). */
  public timeTracking: TimeTrackingResource
  public performanceReviews: PerformanceReviewsResource
  public goals: GoalsResource
  public oneOnOnes: OneOnOnesResource
  public upvotes: UpvotesResource
  public networking: NetworkingResource
  /** F-178: Podcast and Vídeos shows and episodes. */
  public mediaShows: MediaShowsResource
  /** F-218: the member's own notes in the lesson and episode players. */
  public playerNotes: PlayerNotesResource
  /** F-233: two-step verification (login step, Segurança, step-up, SuperAdmin reset). */
  public twoFactor: TwoFactorResource
  /** F-249: the Attendance day passes ("Pacote de passes"): wallet, team adjustment and report. */
  public dayPasses: DayPassesResource
  /** F-138: the Canal module (messages, threads, reactions, unread). */
  public channels: ChannelsResource
  /** F-49: private feedbacks and requests between colleagues, and the team's numbers. */
  public feedbacks: FeedbacksResource
  /** F-104: the member's e-mail categories, the one-click unsubscribe, the publish forms' recipient count. */
  public emailNotices: EmailNoticesResource
  /** F-186: this person's push devices and preferences. */
  public push: PushResource
  /** F-142: the SMS channel, the phone code, "Avisos desta comunidade" and the contact consents. */
  public sms: SmsResource
  public whatsapp: WhatsappResource
  /** F-140: the e-mail library and the default e-mails a community replaces. */
  public emails: EmailsResource
  /** F-144: the community vault (secrets for the workflows' HTTP node). */
  public vault: VaultResource
  /** F-155 + F-190: the community's welcome and the "Primeiros passos" missions. */
  public welcome: WelcomeResource
  /** F-164: "Agendados", the posts waiting for their time. */
  public scheduledPosts: ScheduledPostsResource
  /** F-141: workflows (automations by trigger). */
  public workflows: WorkflowsResource
  /** F-108 Mensagens: 1:1 chat, presence and blocks (the socket ticket is `realtime`). */
  public chat: ChatResource
  /** F-110: the platform socket's ticket. */
  public realtime: RealtimeResource
  public subscriptions: SubscriptionsResource
  /** F-45: the team's view of the community's subscriptions. */
  public subscriptionAdmin: SubscriptionAdminResource
  /** F-55: the community's sales and their refunds. */
  public sales: SalesResource
  /** F-102: checkouts opened and not paid (abandoned carts). */
  public abandonedCarts: AbandonedCartsResource
  public integrations: IntegrationsResource
  /** F-101 1b: community webhooks, on the developers-api. */
  public webhooks: WebhooksResource
  /** F-101 1c: ready-made integrations, on the developers-api. */
  public apps: AppsResource
  /** Administração › Logs: the community's timeline; owner/admin, finance only financial. */
  public logs: LogsResource
  public engagement: EngagementResource
  /** F-88: the community's own analytics (overview, pageviews, funnel, online now, realtime). */
  public analytics: AnalyticsResource
  public upload: UploadResource
  public businessInformation: BusinessInformationResource
  public payoutSettings: PayoutSettingsResource
  public notifications: NotificationsResource
  public search: SearchResource
  public products: ProductsResource
  public coupons: CouponsResource
  public subscriptionGroups: SubscriptionGroupsResource
  public checkout: CheckoutResource
  public ledger: LedgerResource
  public payouts: PayoutsResource
  public reports: ReportsResource
  public fees: FeesResource
  public paymentMethods: PaymentMethodsResource
  public downsell: DownsellResource
  public adminFees: AdminFeesResource
  public adminCommunities: AdminCommunitiesResource
  /** F-143: sending reputation (SuperAdmin). */
  public adminSendingReputation: AdminSendingReputationResource
  public entitlements: EntitlementsResource
  public hubListing: HubListingResource
  /** F-191 phase 4: the community's themes and the ready-made gallery. */
  public communityThemes: CommunityThemesResource
  public adminCommunityRequests: AdminCommunityRequestsResource
  public mcpOAuth: McpOAuthResource
  public customDomain: CustomDomainResource
  /** F-197b: the community's video signing keys (Bunny, Cloudflare). */
  public videoIntegrations: VideoIntegrationsResource
  /** F-188: e-mail through the community's own Resend account. */
  public emailProvider: EmailProviderResource

  constructor() {
    this.ctx = new SdkContext()
    this.currentLocale = normalizeLocale(localStorage.getItem(LOCALE_STORAGE_KEY) || 'en-US')

    this.auth = new AuthResource(this.ctx)
    this.twoFactor = new TwoFactorResource(this.ctx)
    this.call4papers = new Call4PapersResource(this.ctx)
    this.certificates = new CertificatesResource(this.ctx)
    this.campaigns = new CampaignsResource(this.ctx)
    this.dashboard = new DashboardResource(this.ctx)
    this.classifieds = new ClassifiedsResource(this.ctx)
    this.attendance = new AttendanceResource(this.ctx)
    this.visitors = new VisitorsResource(this.ctx)
    this.bookings = new BookingsResource(this.ctx)
    this.scheduling = new SchedulingResource(this.ctx)
    this.parcels = new ParcelsResource(this.ctx)
    this.virtualOffice = new VirtualOfficeResource(this.ctx)
    this.companies = new CompaniesResource(this.ctx)
    this.support = new SupportResource(this.ctx)
    this.credits = new CreditsResource(this.ctx)
    this.downloads = new DownloadsResource(this.ctx)
    this.media = new MediaResource(this.ctx)
    this.adminMedia = new AdminMediaResource(this.ctx)
    this.storefront = new StorefrontResource(this.ctx)
    this.referrals = new ReferralsResource(this.ctx)
    this.points = new PointsResource(this.ctx)
    this.communities = new CommunitiesResource(this.ctx)
    this.content = new ContentResource(this.ctx)
    this.courses = new CoursesResource(this.ctx)
    this.events = new EventsResource(this.ctx)
    this.feed = new FeedResource(this.ctx)
    this.gallery = new GalleryResource(this.ctx)
    this.gamification = new GamificationResource(this.ctx)
    this.badges = new BadgesResource(this.ctx)
    this.signupRequests = new SignupRequestsResource(this.ctx)
    this.members = new MembersResource(this.ctx)
    this.sections = new SectionsResource(this.ctx)
    this.spaces = new SpacesResource(this.ctx)
    this.memberGroups = new MemberGroupsResource(this.ctx)
    this.memberFields = new MemberFieldsResource(this.ctx)
    this.memberImports = new MemberImportsResource(this.ctx)
    this.contentImports = new ContentImportsResource(this.ctx)
    this.inviteOptOut = new InviteOptOutResource(this.ctx)
    this.hierarchy = new HierarchyResource(this.ctx)
    this.status = new StatusResource(this.ctx)
    this.embeds = new EmbedsResource(this.ctx)
    this.ai = new AiResource(this.ctx)
    this.polls = new PollsResource(this.ctx)
    this.surveys = new SurveysResource(this.ctx)
    this.forms = new FormsResource(this.ctx)
    this.exports = new ExportsResource(this.ctx)
    this.privacy = new PrivacyResource(this.ctx)
    this.recognitions = new RecognitionsResource(this.ctx)
    this.developmentPlans = new DevelopmentPlansResource(this.ctx)
    this.timeTracking = new TimeTrackingResource(this.ctx)
    this.performanceReviews = new PerformanceReviewsResource(this.ctx)
    this.goals = new GoalsResource(this.ctx)
    this.oneOnOnes = new OneOnOnesResource(this.ctx)
    this.upvotes = new UpvotesResource(this.ctx)
    this.networking = new NetworkingResource(this.ctx)
    this.mediaShows = new MediaShowsResource(this.ctx)
    this.playerNotes = new PlayerNotesResource(this.ctx)
    this.dayPasses = new DayPassesResource(this.ctx)
    this.channels = new ChannelsResource(this.ctx)
    this.feedbacks = new FeedbacksResource(this.ctx)
    this.emailNotices = new EmailNoticesResource(this.ctx)
    this.push = new PushResource(this.ctx)
    this.sms = new SmsResource(this.ctx)
    this.whatsapp = new WhatsappResource(this.ctx)
    this.emails = new EmailsResource(this.ctx)
    this.vault = new VaultResource(this.ctx)
    this.welcome = new WelcomeResource(this.ctx)
    this.scheduledPosts = new ScheduledPostsResource(this.ctx)
    this.workflows = new WorkflowsResource(this.ctx)
    this.chat = new ChatResource(this.ctx)
    this.realtime = new RealtimeResource(this.ctx)
    this.subscriptions = new SubscriptionsResource(this.ctx)
    this.subscriptionAdmin = new SubscriptionAdminResource(this.ctx)
    this.sales = new SalesResource(this.ctx)
    this.abandonedCarts = new AbandonedCartsResource(this.ctx)
    this.integrations = new IntegrationsResource(this.ctx)
    this.webhooks = new WebhooksResource(this.ctx)
    this.apps = new AppsResource(this.ctx)
    this.logs = new LogsResource(this.ctx)
    this.engagement = new EngagementResource(this.ctx)
    this.analytics = new AnalyticsResource(this.ctx)
    this.upload = new UploadResource(this.ctx)
    this.businessInformation = new BusinessInformationResource(this.ctx)
    this.payoutSettings = new PayoutSettingsResource(this.ctx)
    this.notifications = new NotificationsResource(this.ctx)
    this.search = new SearchResource(this.ctx)
    this.products = new ProductsResource(this.ctx)
    this.coupons = new CouponsResource(this.ctx)
    this.subscriptionGroups = new SubscriptionGroupsResource(this.ctx)
    this.checkout = new CheckoutResource(this.ctx)
    this.ledger = new LedgerResource(this.ctx)
    this.payouts = new PayoutsResource(this.ctx)
    this.reports = new ReportsResource(this.ctx)
    this.fees = new FeesResource(this.ctx)
    this.paymentMethods = new PaymentMethodsResource(this.ctx)
    this.downsell = new DownsellResource(this.ctx)
    this.adminFees = new AdminFeesResource(this.ctx)
    this.adminCommunities = new AdminCommunitiesResource(this.ctx)
    this.adminSendingReputation = new AdminSendingReputationResource(this.ctx)
    this.entitlements = new EntitlementsResource(this.ctx)
    this.hubListing = new HubListingResource(this.ctx)
    this.communityThemes = new CommunityThemesResource(this.ctx)
    this.adminCommunityRequests = new AdminCommunityRequestsResource(this.ctx)
    this.mcpOAuth = new McpOAuthResource(this.ctx)
    this.customDomain = new CustomDomainResource(this.ctx)
    this.videoIntegrations = new VideoIntegrationsResource(this.ctx)
    this.emailProvider = new EmailProviderResource(this.ctx)
  }

  private async applyState(): Promise<void> {
    const client = await this.ctx.ready
    const token = localStorage.getItem('memberfy_auth_token') || ''
    const memberId = localStorage.getItem(MEMBER_STORAGE_KEY) || ''

    if (token) client.setToken(token)
    if (memberId) client.config.memberId = memberId
    if (this.currentLocale) client.setLanguage(this.currentLocale)
  }

  setToken(token: string) {
    if (token) {
      localStorage.setItem('memberfy_auth_token', token)
    } else {
      localStorage.removeItem('memberfy_auth_token')
    }
    this.ctx.ready
      .then(client => client.setToken(token || (null as unknown as string)))
      .catch(() => {})
  }

  setCommunityId(id: string) {
    this.currentCommunityId = id || ''
    this.ctx.ready.then(client => client.setCommunity(id || (null as unknown as string))).catch(() => {})
  }

  /** Empty until the community has been resolved from the domain. */
  getCommunityId() {
    return this.currentCommunityId
  }

  /**
   * Sets (or clears, with `''`) the `X-MemberId` header — "act as this
   * member", a SuperAdmin-only power. The id is stored together with the
   * community it belongs to, so it can be dropped in any other community.
   * Written on the client's state, which is what the header is built from.
   */
  setMemberId(id: string) {
    /* F-174: another acting member ("agir como") or none: the blocks' kept drafts are not theirs. */
    if ((localStorage.getItem(MEMBER_STORAGE_KEY) || '') !== (id || '')) clearBlockDrafts()
    if (id) {
      localStorage.setItem(MEMBER_STORAGE_KEY, id)
      localStorage.setItem(MEMBER_COMMUNITY_STORAGE_KEY, this.currentCommunityId)
    } else {
      localStorage.removeItem(MEMBER_STORAGE_KEY)
      localStorage.removeItem(MEMBER_COMMUNITY_STORAGE_KEY)
    }
    this.ctx.ready.then(client => { client.config.memberId = id || null }).catch(() => {})
  }

  getCurrentMember() {
    return localStorage.getItem(MEMBER_STORAGE_KEY) || ''
  }

  /** The community the stored member id was chosen in; `''` when unknown. */
  getCurrentMemberCommunity() {
    return localStorage.getItem(MEMBER_COMMUNITY_STORAGE_KEY) || ''
  }

  setLocale(locale: string) {
    this.currentLocale = normalizeLocale(locale)
    this.ctx.ready.then(client => client.setLanguage(this.currentLocale)).catch(() => {})
  }

  // Resolves once the official SDK is loaded and stored token/member/locale
  // have been applied. Await this before the first authenticated call.
  async initialize(): Promise<void> {
    await this.ctx.ready
    await this.applyState()
  }
}

export const sdk = new MemberfySDK()

export const getOfficialSdkUrl = async (): Promise<string> => {
  const { getSdkUrl } = await import('./sdk-official/loader')
  return getSdkUrl()
}
